import React from 'react';

import { PrimaryButton } from '@components/Button/variants';
import { edit_profile_settings_path, subscribe_path } from '@routes';
import { ForumPostsResult } from '@utils/backend-api/forumPosts';
import { SubscriberDirectoryResponse } from '@utils/backend-api/subscriber_directory';

import SubscribersList from './SubscribersList';

const DirectorySearchResults = ({
  data,
}: {
  data: ForumPostsResult | SubscriberDirectoryResponse;
}) => {
  if (data?.canViewDirectory) {
    return (
      <SubscribersList content={{ profiles: data?.profiles, currentUserId: data?.currentUserId }} />
    );
  }

  return data?.currentUserStatus > 0 ? (
    <div className="mt-24 flex flex-col items-center text-center text-grayscale-gray">
      <p className="font-suisse-intl text-subheadline-sm">
        You must enable your profile to search the directory.
      </p>
      <PrimaryButton className="mt-24" as="link" href={edit_profile_settings_path()}>
        Go to profile settings
      </PrimaryButton>
    </div>
  ) : (
    <div className="mt-24 flex flex-col items-center text-center text-grayscale-gray">
      <p className="font-suisse-intl text-subheadline-sm">
        You do not have access to view the directory. Subscribe to access.
      </p>
      <PrimaryButton className="mt-24" as="link" href={subscribe_path()}>
        Subscribe
      </PrimaryButton>
    </div>
  );
};

export default DirectorySearchResults;
